import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Smart translation pipe that handles both simple translation keys and parameterized translations
 * 
 * Usage:
 * - Simple: {{ 'COMMON.SAVE' | translateSmart }}
 * - Parameterized: {{ '{"key":"VALIDATION.RANGE_MIN","params":{"min":5,"unit":" cm"}}' | translateSmart }}
 * 
 */
@Pipe({
    name: 'translateSmart',
})
export class TranslateSmartPipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value: string): string {
        if (!value) {
            return '';
        }

        if (value.startsWith('{') && value.includes('"key"')) {
            try {
                const data = JSON.parse(value);
                if (data.key && data.params) {
                    return this.translate.instant(data.key, data.params);
                }
                return this.translate.instant(value);
            } catch (error) {
                return this.translate.instant(value);
            }
        }

        return this.translate.instant(value);
    }
}